export default __webpack_public_path__ + "static/coding-agent-dark-87cdf11f0c6d167aba9d72961b84b118.png";